import { AppState } from '../index';

export const selectStakingAllStaking = (state: AppState) => state.staking.allStaking;
export const selectStakingStaked = (state: AppState) => state.staking.staked;
export const selectStakingRefetch = (state: AppState) => state.staking.refetch;
export const selectStakingSelectProfessionNft = (state: AppState) => state.staking.selectProfessionNft;
